"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowMoreButton = exports.CareTeamExpandedProviderList = exports.CareTeamProviderList = exports.CareTeamSubtitle = exports.CareTeamTitle = exports.CareTeamHeader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = __importDefault(require("@kyruus/button"));
const provider_components_1 = require("@kyruus/provider-components");
const constants_1 = require("../../lib/constants");
exports.CareTeamHeader = styled_1.default.div `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.CareTeamTitle = styled_1.default.h2 `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: 0;
`;
exports.CareTeamSubtitle = styled_1.default.p `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} 0 0 0;
`;
// Should match AltProvidersList styles for now
exports.CareTeamProviderList = (0, styled_1.default)(provider_components_1.MiniProviderCardList) `
  > div {
    width: 100%;
    @media screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
      width: calc(50% - 8px);
    }
  }
`;
exports.CareTeamExpandedProviderList = (0, styled_1.default)(exports.CareTeamProviderList) `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.ShowMoreButton = (0, styled_1.default)(button_1.default) `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
//# sourceMappingURL=styles.js.map